import { getLevelForXP } from '@/domain/level'

// Renders whatever getLevelForXP() returns — no level names or thresholds
// hard-coded here, so LEVELS in src/domain/level.ts is the only place that
// ever needs to change (Document 11 §P4 "data-driven, not hard-coded").
export function LevelBadge({ xpTotal, compact = false }: { xpTotal: number; compact?: boolean }) {
  const level = getLevelForXP(xpTotal)

  if (compact) {
    return (
      <span className="cyber-pill bg-indigo-500/15 text-indigo-300 ring-1 ring-indigo-500/30">
        Lv.{level.level} {level.name}
      </span>
    )
  }

  return (
    <div className="cyber-panel p-5">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs uppercase tracking-wide text-white/50">Level {level.level}</p>
          <p className="font-display text-lg font-bold text-white">{level.name}</p>
        </div>
        <span className="font-display text-2xl font-bold gradient-text">{level.currentXP}</span>
      </div>
      {level.nextLevelName ? (
        <div className="mt-3">
          <div className="h-1.5 w-full overflow-hidden rounded-full bg-white/10">
            <div className="h-full rounded-full bg-gradient-to-r from-indigo-400 to-teal-400" style={{ width: `${level.progressPercent}%` }} />
          </div>
          <p className="mt-1 text-xs text-white/40">
            {level.xpForNextLevel! - level.xpIntoLevel} XP to {level.nextLevelName}
          </p>
        </div>
      ) : (
        <p className="mt-3 text-xs text-white/40">Max level reached</p>
      )}
    </div>
  )
}
